import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { IGetServiceProps } from "@api/types/globalService.types";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { useState } from "react";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllCommissionsService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";

  const allCommissionsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.COMMISSIONS,
      page,
      debouncedQuery,
      per_page,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.COMMISSIONS,
        searchParams: {
          "filter[beneficiaryable_type]": debouncedQuery,
          "filter[created_between]": created_between,
          page,
          per_page,
          include: "beneficiaryable,commissionable",
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allCommissionsService },
    states: { searchQuery, setSearchQuery },
  };
};
